import { useEffect, useMemo, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ApiRequestBuilder, ToastBuilder } from '../Builders/index'

function buildRandomId(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

function performStringSearch(str, code = null, pattern = null) {

    switch (code) {
        case 'special':
            pattern = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
            break;
        case 'uppercase':
            pattern = /[A-Z]/;
            break;
        case 'lowercase':
            pattern = /[a-z]/;
            break;
        case 'number':
            pattern = /[0-9]/;
            break;
        default:
            pattern = /[a-zA-Z]/;
            break;
    }

    return pattern.test(str);
}

// https://stackoverflow.com/questions/1026069/how-do-i-make-the-first-letter-of-a-string-uppercase-in-javascript
function capitalizeFirstLetter(string) {

    // Automatically uppercase first letter of each word
    if (string.indexOf(' ')) {
        return string.split(' ').map(chunk => chunk.charAt(0).toUpperCase() + chunk.slice(1)).join(' ')
    }

    return string.charAt(0).toUpperCase() + string.slice(1);
}

function lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}

function rekeyArray(array, target) {

    let rekeyed_array = {};

    target = target.includes('/') ? target.split('/') : target;

    array.map((element) => {

        if (typeof target === 'string') {

            rekeyed_array[String(element[target])] = element;

        } else {

            rekeyed_array[String(element[target[0]][target[1]])] = element;

        }
    })

    return rekeyed_array;
}

function reduceArray(array, uniqueKey, includeKeys = null) {

    const seen = new Set();
    const reduced = [];

    array.forEach(obj => {
        const keyValue = obj[uniqueKey];
        if (!seen.has(keyValue)) {
            seen.add(keyValue);

            const filteredObj = includeKeys ? includeKeys.reduce((acc, key) => {
                if (key in obj) acc[key] = obj[key];
                return acc;
            }, {})
                : obj;

            reduced.push(filteredObj);
        }
    });

    return reduced;
}

function createValuesArray(array, key) {
    var newArray = [];

    array.forEach(function (arr) {
        newArray.push(arr[key]);
    });

    return newArray;
}

const uploadPresignedFile = (fileObject, sdkPath, params = {}, body = {}, callback = () => { }, options = {}) => {

    return ApiRequestBuilder(sdkPath, params, body)
        .then(function (results) {

            const formData = new FormData();

            Object.keys(results.data.fields).forEach((field) => {
                formData.append(field, results.data.fields[field]);
            })

            /**
             * The file has to be added last...
             * https://medium.com/@spenceraford/using-python-lambdas-javascript-to-get-photos-to-s3-83ddde1ef5b
             */
            formData.append("file", fileObject[0]);

            fetch(results.data.url, { method: 'POST', body: formData })
                .then(e => {
                    if (e.status === 200 || e.status === 204) {
                        ToastBuilder('success', 'File Uploaded Successfully')
                        // Apparently this refresh of the data is faster than the db so we need a delay
                        setTimeout(() => { callback() }, options.timeout ? options.timeout : '3000')
                    } else ToastBuilder('error', 'Something Went Wrong, Please Try Again')
                })
                .catch(err => {

                    ToastBuilder('success', 'File Uploaded Successfully')
                    // Apparently this refresh of the data is faster than the db so we need a delay
                    setTimeout(() => { callback() }, options.timeout ? options.timeout : '3000')

                    console.warn('err', err.message)
                })
        })
}

/**
 * Due to the way react works or at least how we understand it at this point. If we
 * fetch data via an API call and then try to populate form fields with the information
 * we receive using registrationSettings, it doesn't work. If it is hard coded it works
 * so we assume it is a timing thing. This function is designed to set all the initial
 * form values based on the data retrieved. We loop through all the column names while
 * blindy setting form fields whose name matches that of the camelCase form of the column
 * name.
 */
const setInitialFormValues = (data, setValue, appendId = null) => {

    if (!data) {
        ToastBuilder('error', 'No Data Found');
    }

    if (typeof data === 'object' && !Array.isArray(data)) {
        Object.keys(data).map((column) => {

            let suffix = ''
            let split_column = column.split('_')

            split_column.shift()

            let camelCaseColumn = split_column.map((column_part) => {
                return capitalizeFirstLetter(column_part)
            })
            /* update: if the column value is 0, we also want to set it */
            let column_value = data[column] || data[column] === 0 ? data[column] : ''

            /**
             * In cases where we need to create a unique modal for each row
             * in a table, we'll need to append some value to the name of each
             * form to not overwrite the wrong input
             */
            if (appendId) {
                suffix = String(data[appendId])
            }

            if (column_value !== 'None') {
                setValue(column.split('_')[0] + camelCaseColumn.join('') + suffix, typeof column_value === 'object' ? JSON.stringify(column_value) : column_value)
            }
        })
    }
    else {
        data.forEach(obj => {
            Object.keys(obj).map((column) => {

                let suffix = ''
                let split_column = column.split('_')

                split_column.shift()

                let camelCaseColumn = split_column.map((column_part) => {
                    return capitalizeFirstLetter(column_part)
                })

                let column_value = obj[column] || data[column] === 0 ? obj[column] : ''

                /**
                 * In cases where we need to create a unique modal for each row
                 * in a table, we'll need to append some value to the name of each
                 * form to not overwrite the wrong input
                 */
                if (appendId) {
                    suffix = String(obj[appendId])
                }

                if (column_value !== 'None') {
                    setValue(column.split('_')[0] + camelCaseColumn.join('') + suffix, typeof column_value === 'object' ? JSON.stringify(column_value) : column_value)
                }
            })
        })
    }
}

/*
    * @param data - Data on state variable(populated from Handler or onClick button)
    * @param newData - Data on the form fields
    * @param format? - The format of the output's keys, either camel or snake
    * @param exclude? - The keys that we don't want to update

    * This function aims to reduce the amount of data that is sent on the body of UPDATE requests
        by comparing the data stored on a state variable, and the data from the forms fields.
    * We can use Object.keys(data).length to determine if the Request needs to be made
    * In case the keys for the objects are in different formats, we can be explicit about
        the outputs's. Can be skipped if the format is the same
    * We can also exclude keys that we don't want to update(in the format specified) such as 'ids' or PKs
*/
const setUpdateValues = (data, newData, format = null, exclude = []) => {

    let toUpdate = {}

    if (format === 'camel') {
        data = renameKeysSnakeToCamel(data)
        newData = renameKeysSnakeToCamel(newData)
    }
    if (format === 'snake') {
        data = renameKeysCamelToSnake(data)
        newData = renameKeysCamelToSnake(newData)
    }

    Object.keys(newData).map((column) => {
        // Skip undefined values (field not registered in form)
        if (newData[column] === undefined) return;
        // Coerce both to string for comparison to handle number vs string mismatches from form inputs
        const oldVal = data[column] === null || data[column] === undefined ? '' : String(data[column]);
        const newVal = newData[column] === null || newData[column] === undefined ? '' : String(newData[column]);
        if (oldVal !== newVal && !exclude.includes(column)) toUpdate[column] = newData[column]
    })

    return toUpdate

}

const convertTimestampToTimePicker = (timestamp) => {
    var curr = new Date(timestamp * 1000);
    curr.setDate(curr.getDate());
    return curr.toISOString().substr(0, 10);
}

const resetAllFormFields = (formData, resetFieldFunction) => {
    Object.keys(formData).forEach(field => resetFieldFunction(field))
}

const buildStaffOptions = (setData) => {

    ApiRequestBuilder('staffGet').then(function (results) {
        setData(results.data.map((items, i) =>
            <option value={items.user_id} key={items.user_id}>{items.first_name + ' ' + items.last_name}</option>
        ))
    })
}

const convertArrayToCSV = (data) => {
    const csvRows = [];

    // Get the headers
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(','));

    // Loop over the rows
    for (const row of data) {
        const values = headers.map(header => row[header]);
        csvRows.push(values.join(','));
    }

    return csvRows.join('\n');
};

const buildAddressOptions = () => {
    return [];
    /*Country.getAllCountries().map((items, i) =>
        <option key={items.isoCode} value={items.isoCode}>{capitalizeFirstLetter(items.name)}</option>
    )*/
}

const groupObjectsByKey = (objList, key) => {
    return objList.reduce((acc, obj) => {
        const groupKey = obj[key];
        if (!acc[groupKey]) {
            acc[groupKey] = [];
        }
        acc[groupKey].push(obj);
        return acc;
    }, {});
}

const buildOptionsFromArray = (optionArray = [], optionSettings = {}, optionsToOmit = []) => {

    var filteredOptionArray = optionArray.filter(element => !optionsToOmit.includes(element[optionSettings.value]))

    var finalOptionArray = filteredOptionArray.map((option, i) => {
        let label = optionSettings.label ? option[optionSettings.label] : option
        let value = optionSettings.value ? option[optionSettings.value] : optionSettings.labelIsValue ? option : i

        const result = { label, value }

        if (optionSettings.groupKey) {
            const groupName = option[optionSettings.groupKey]
            const groupLabel = option['group_label']
            result[optionSettings.groupKey] = groupLabel ? `${groupName} - ${groupLabel}` : groupName
        }

        return result
    })

    if (optionSettings.groupKey) {
        return groupObjectsByKey(sortArrayByKey(finalOptionArray, 'label'), optionSettings.groupKey)
    }

    return finalOptionArray

}

/*
    Build grouped react-select options from grouped object
    Expects object: { groupName: [{ label: '', value: '' }] }
    Returns array: [{ label: 'groupName', options: [...] }]
*/
const buildGroupedOptionsFromObject = (groupedOptions) => {
    return Object.keys(groupedOptions).sort().map(group => ({
        label: group,
        options: groupedOptions[group].map(item => ({
            value: item.value,
            label: item.label
        }))
    }));
}

// Build react-select options directly from array
const buildSelectOptionsFromArray = (optionArray, optionSettings = {}, optionsToOmit = []) => {
    const builtOptions = buildOptionsFromArray(optionArray, optionSettings, optionsToOmit);
    return optionSettings.groupKey ? buildGroupedOptionsFromObject(builtOptions) : builtOptions;
}

// Find selected option in react-select options (handles both flat and grouped)
const findReactSelectValue = (selectOptions, watchedValue, treatZeroAsEmpty = true, treatNullAsEmpty = true) => {
    if (watchedValue === undefined || !selectOptions) return null;
    if (treatNullAsEmpty && watchedValue === null) return null;
    if (watchedValue === '') return null;
    if (treatZeroAsEmpty && (watchedValue === 0 || watchedValue === '0')) return null;

    // Handle grouped options
    if (selectOptions.some(option => option.options)) {
        for (const group of selectOptions) {
            if (group.options) {
                const found = group.options.find(option => String(option.value) === String(watchedValue));
                if (found) return found;
            }
        }
        return { value: watchedValue, label: `Unknown: ${watchedValue}` };
    }

    // Handle flat options
    const found = selectOptions.find(option => String(option.value) === String(watchedValue));
    return found || { value: watchedValue, label: `Unknown: ${watchedValue}` };
}

const sortArrayByKey = (array, key) => {
    return array.sort(function (a, b) {
        if (Object.prototype.toString.call(a[key]) === "[object String]" && Object.prototype.toString.call(b[key]) === "[object String]") {
            var x = a[key].toLowerCase(); var y = b[key].toLowerCase();
        }
        else {
            var x = a[key]; var y = b[key];
        }
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

const sortArrayByKeys = (array, keys) => {
    return array.sort((a, b) => {
        for (const keyConfig of keys) {
            const key = typeof keyConfig === 'object' ? Object.keys(keyConfig)[0] : keyConfig;
            const ascending = typeof keyConfig === 'object' ? keyConfig[key] : true;
            const result = sortByKey(a, b, key);
            if (result !== 0) return [true, 'ASC', 'asc'].includes(ascending) ? result : -result;
        }
        return 0;
    });
}

const getStaticArray = (arrayName) => {

    switch (arrayName) {
        case 'numbers':
            var countArray = [];
            for (let step = 1; step < 100; step++) {
                countArray.push({
                    num: step,
                });
            }

            return countArray;

        case 'markets':
            return [
                { id: 1, name: 'Financial Services' },
                { id: 48, name: 'Law firm' },
                { id: 32, name: 'Healthcare, Pharma & Biotech' },
                { id: 50, name: 'Government' },
            ];

        case 'usStates':
            return [
                { isoCode: 'AL', name: 'Alabama' },
                { isoCode: 'AK', name: 'Alaska' },
                { isoCode: 'AZ', name: 'Arizona' },
                { isoCode: 'AR', name: 'Arkansas' },
                { isoCode: 'CA', name: 'California' },
                { isoCode: 'CO', name: 'Colorado' },
                { isoCode: 'CT', name: 'Connecticut' },
                { isoCode: 'DE', name: 'Delaware' },
                { isoCode: 'DC', name: 'District Of Columbia' },
                { isoCode: 'FL', name: 'Florida' },
                { isoCode: 'GA', name: 'Georgia' },
                { isoCode: 'HI', name: 'Hawaii' },
                { isoCode: 'ID', name: 'Idaho' },
                { isoCode: 'IL', name: 'Illinois' },
                { isoCode: 'IN', name: 'Indiana' },
                { isoCode: 'IA', name: 'Iowa' },
                { isoCode: 'KS', name: 'Kansas' },
                { isoCode: 'KY', name: 'Kentucky' },
                { isoCode: 'LA', name: 'Louisiana' },
                { isoCode: 'ME', name: 'Maine' },
                { isoCode: 'MD', name: 'Maryland' },
                { isoCode: 'MA', name: 'Massachusetts' },
                { isoCode: 'MI', name: 'Michigan' },
                { isoCode: 'MN', name: 'Minnesota' },
                { isoCode: 'MS', name: 'Mississippi' },
                { isoCode: 'MO', name: 'Missouri' },
                { isoCode: 'MT', name: 'Montana' },
                { isoCode: 'NE', name: 'Nebraska' },
                { isoCode: 'NV', name: 'Nevada' },
                { isoCode: 'NH', name: 'New Hampshire' },
                { isoCode: 'NJ', name: 'New Jersey' },
                { isoCode: 'NM', name: 'New Mexico' },
                { isoCode: 'NY', name: 'New York' },
                { isoCode: 'NC', name: 'North Carolina' },
                { isoCode: 'ND', name: 'North Dakota' },
                { isoCode: 'OH', name: 'Ohio' },
                { isoCode: 'OK', name: 'Oklahoma' },
                { isoCode: 'OR', name: 'Oregon' },
                { isoCode: 'PA', name: 'Pennsylvania' },
                { isoCode: 'RI', name: 'Rhode Island' },
                { isoCode: 'SC', name: 'South Carolina' },
                { isoCode: 'SD', name: 'South Dakota' },
                { isoCode: 'TN', name: 'Tennessee' },
                { isoCode: 'TX', name: 'Texas' },
                { isoCode: 'UT', name: 'Utah' },
                { isoCode: 'VT', name: 'Vermont' },
                { isoCode: 'VA', name: 'Virginia' },
                { isoCode: 'WA', name: 'Washington' },
                { isoCode: 'WV', name: 'West Virginia' },
                { isoCode: 'WI', name: 'Wisconsin' },
                { isoCode: 'WY', name: 'Wyoming' }
            ];

        default: return []
    }

}

const renameKeysSnakeToCamel = (obj) => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        const camelKey = key.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
        acc[camelKey.charAt(0).toLowerCase() + camelKey.slice(1)] = value;
        return acc;
    }, {});
}

const renameKeysCamelToSnake = (obj) => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        const snakeKey = key.replace(/[A-Z]/g, (match) => '_' + match.toLowerCase());
        acc[snakeKey.toLowerCase()] = value;
        return acc;
    }, {});
}

const showRelativeTime = (timestamp) => {
    const now = new Date();
    // Auto-detect unix seconds (10 digits) vs milliseconds (13 digits) vs date strings
    let ts = timestamp;
    if (typeof ts === 'number' || /^\d+$/.test(ts)) {
        ts = Number(ts);
        if (ts < 1e12) ts *= 1000; // seconds → milliseconds
    }
    const timeDiff = now - new Date(ts);

    const seconds = Math.floor(timeDiff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''} ago`;
    } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (minutes > 0) {
        return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else {
        return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
    }
}

const showTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
}

/**
 * Render a timestamp on two lines to save horizontal space (useful for narrow/
 * mobile table columns). Reusable anywhere a compact two-line date/time helps.
 *
 * By default: time on top (larger, NOT bold), date on bottom (smaller, dimmed).
 *
 * @param {number|string|Date} timestamp  Anything the Date constructor accepts.
 * @param {Object}  options
 * @param {boolean} options.bold       Bold the top line (default false).
 * @param {boolean} options.dateFirst  Put date on top, time on bottom (default false).
 * @param {string}  options.topSize    Font size of the top line (default '1em').
 * @param {string}  options.bottomSize Font size of the bottom line (default '0.85em').
 * @param {string}  options.align      flex align-items (default 'flex-start').
 */
const showTimestampStacked = (timestamp, options = {}) => {
    const {
        bold = false,
        dateFirst = false,
        topSize = '1em',
        bottomSize = '0.85em',
        align = 'flex-start',
    } = options;

    const date = new Date(timestamp);
    const timePart = date.toLocaleTimeString();
    const datePart = date.toLocaleDateString();
    const top = dateFirst ? datePart : timePart;
    const bottom = dateFirst ? timePart : datePart;

    return (
        <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: align, lineHeight: 1.2 }}>
            <span style={{ fontSize: topSize, fontWeight: bold ? 600 : 400 }}>{top}</span>
            <span style={{ fontSize: bottomSize, opacity: 0.75 }}>{bottom}</span>
        </span>
    );
}

/**
 * useIsMobile — reactive viewport check. Returns true when the viewport width
 * is at or below the breakpoint (default 991px, matching the app's existing
 * mobile cutoff used by the sidebar/header). Updates on resize.
 */
const useIsMobile = (breakpoint = 991) => {
    const query = `(max-width: ${breakpoint}px)`;
    const [isMobile, setIsMobile] = useState(() =>
        typeof window !== 'undefined' && window.matchMedia
            ? window.matchMedia(query).matches
            : (typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false)
    );

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return;
        const mql = window.matchMedia(query);
        const onChange = (e) => setIsMobile(e.matches);
        // addEventListener is the modern API; fall back to addListener for older Safari.
        mql.addEventListener ? mql.addEventListener('change', onChange) : mql.addListener(onChange);
        setIsMobile(mql.matches);
        return () => {
            mql.removeEventListener ? mql.removeEventListener('change', onChange) : mql.removeListener(onChange);
        };
    }, [query]);

    return isMobile;
}

const isAdminUser = (userSession) => {
    if (userSession['custom:emulationActive'] === 'true' || userSession['custom:partnerId'] === '0') return true
    return false
}

const handleRequiredFields = (formFields, requiredFields, message = 'Missing Required Fields') => {
    const isValid = requiredFields.some((field) => {
        if (!formFields[field]) {
            ToastBuilder('error', message);
            return true;
        }
        return false;
    });

    return !isValid;
};

const submitHandler = (handleSubmit, onSubmit, action = null) => {
    return (e) => {
        e.preventDefault();
        if (action) increase(action);
        handleSubmit(onSubmit)();
    };
};

const increase = (setVariable) => {
    try {
        setVariable((prev) => prev + 1)
    } catch (e) { console.warm(e.message) }
};

const statusCodeText = (status) => {
    switch (status) {
        case 200: return 'OK'
        case 201: return 'Created'
        case 202: return 'Accepted'
        case 204: return 'No Content'
        case 400: return 'Bad Request'
        case 401: return 'Unauthorized'
        case 403: return 'Forbidden'
        case 404: return 'Not Found'
        case 500: return 'Internal Server Error'
        case 502: return 'Bad Gateway'
        case 503: return 'Service Unavailable'
        default: return 'Unknown Status'
    }
};

const parseTextFromHTML = (htmlString) => {
    const parser = new DOMParser();

    const doc = parser.parseFromString(htmlString, 'text/html');

    return doc.body.textContent || "";
};

/**
 * formatCWMNotes — Converts CWM pseudo-markdown to displayable HTML.
 * CWM uses: **bold**, *italic*, \n for line breaks, and sometimes raw HTML.
 * Returns a string safe for dangerouslySetInnerHTML.
 */
const formatCWMNotes = (text) => {
    if (!text) return '';
    let html = text;
    // Escape any < that aren't already part of HTML tags (basic safety)
    // Skip this if the text already contains HTML tags
    const hasHtmlTags = /<[a-z][\s\S]*>/i.test(html);
    if (!hasHtmlTags) {
        html = html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    // Bold: **text** → <strong>text</strong>
    html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    // Italic: *text* → <em>text</em> (but not inside **)
    html = html.replace(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/g, '<em>$1</em>');
    // Line breaks: \n → <br>
    html = html.replace(/\n/g, '<br/>');
    // Horizontal rules: --- or ─── (unicode box drawing)
    html = html.replace(/^-{3,}$/gm, '<hr/>');
    html = html.replace(/─{3,}/g, '<hr/>');
    return html;
};

const insertTab = (e) => {
    if (e.key === 'Tab') {
        e.preventDefault();
        var start = e.target.selectionStart;
        var end = e.target.selectionEnd;
        e.target.value = e.target.value.substring(0, start) + '\t' + e.target.value.substring(end);
        e.target.selectionStart = e.target.selectionEnd = start + 1;
    }
}

const handleTabOnKeyDown = (e) => {
    if (e.key === 'Tab') {
        e.preventDefault();
        if (e.shiftKey) {
            const input = e.target;
            const start = input.selectionStart;
            const end = input.selectionEnd;
            if (start > 0 && input.value[start - 1] === '\t') {
                const value = input.value;
                input.value = value.slice(0, start - 1) + value.slice(end);
                input.selectionStart = input.selectionEnd = start - 1;
            }
        } else {
            insertTab(e);
        }
    }
}

const parseJSONSafe = (jsonString) => {
    if (!jsonString) return null;
    if (typeof jsonString === 'object' && jsonString !== null) return jsonString;
    if (typeof jsonString === 'string' && jsonString.startsWith('#')) jsonString = jsonString.slice(1);
    try {
        return JSON.parse(jsonString);
    } catch { }
    return String(jsonString);
}

const getJSONDisplayString = (obj, indent = 4) => {
    if (typeof obj === 'object' && obj !== null) {
        try {
            const spaces = ' '.repeat(indent);
            return '#' + JSON.stringify(obj, null, indent).replaceAll(spaces, '\t');
        } catch (e) { console.warn(e.message) }
    }
    return obj ? String(obj) : '';
}

const loadObjectToTextArea = (strObj, indent = 4) => {
    let jsonString = parseJSONSafe(strObj);
    return getJSONDisplayString(jsonString, indent);
}

const stringifyJSONSafe = (obj, tabSize = 0) => {
    if (!obj) return null;
    let jsonString = parseJSONSafe(obj);
    try {
        jsonString = JSON.stringify(obj, null, tabSize);
        return jsonString;
    } catch (e) { console.warn(e.message) }
    return String(jsonString);
}

const convertObjectToString = (obj) => {
    if (!obj) return null;
    let objString = null;
    if (typeof obj === 'object' && obj !== null) {
        try {
            objString = JSON.stringify(obj);
            return objString;
        } catch (e) { console.warn(e.message) }
    }
    return String(obj);
}

const handleTextAreaObjectToString = (strObj) => {
    if (typeof strObj === 'string' && strObj.includes('\u2003')) {
        strObj = strObj.replaceAll(/\u2003/g, ' ');
        console.warn('Special characters found and replaced')
    }
    let obj = parseJSONSafe(strObj);
    return convertObjectToString(obj);
}

const formatJsonAsElements = (obj, indent = 1) => {
    const spaces = '\u00A0'.repeat(indent * 4);
    const elements = [];

    if (Array.isArray(obj)) {
        elements.push(<span>{'['}</span>);
        elements.push(<br />);

        obj.forEach((value, index) => {
            elements.push(<span>{spaces}</span>);

            if (typeof value === 'object' && value !== null) {
                elements.push(...formatJsonAsElements(value, indent + 1));
            } else {
                elements.push(<span className="json-value">{JSON.stringify(value)}</span>);
            }

            if (index < obj.length - 1) {
                elements.push(<span>,</span>);
            }
            elements.push(<br />);
        });

        const parentIndent = '\u00A0'.repeat((indent - 1) * 4);
        elements.push(<span>{parentIndent}{']'}</span>);
    } else {
        elements.push(<span>{'{'}</span>);
        elements.push(<br />);

        const entries = Object.entries(obj);
        entries.forEach(([key, value], index) => {
            elements.push(<span>{spaces}</span>);
            elements.push(<span className="json-key">"{key}"</span>);
            elements.push(<span>: </span>);

            if (typeof value === 'object' && value !== null) {
                elements.push(...formatJsonAsElements(value, indent + 1));
            } else {
                elements.push(<span className="json-value">{JSON.stringify(value)}</span>);
            }

            if (index < entries.length - 1) {
                elements.push(<span>,</span>);
            }
            elements.push(<br />);
        });

        const parentIndent = '\u00A0'.repeat((indent - 1) * 4);
        elements.push(<span>{parentIndent}{'}'}</span>);
    }

    return elements;
}

const jsonPre = (obj, style={fontSize: 15}) => {
    if (!obj) return null
    return <pre key={buildRandomId(7)} className='json-pre' style={style}>{formatJsonAsElements(obj)}</pre>
}

const sortByKey = (a , b, key) => {
    const keyA = a[key];
    const keyB = b[key];

    // Handle null or missing keys
    const isAInvalid = keyA === null || keyA === undefined || keyA === '';
    const isBInvalid = keyB === null || keyB === undefined || keyB === '';

    if (isAInvalid && isBInvalid) return 0; // both invalid
    if (isAInvalid) return 1; // A goes last
    if (isBInvalid) return -1; // B goes last

    // Try numeric comparison first
    const aNum = Number(keyA);
    const bNum = Number(keyB);
    if (!isNaN(aNum) && !isNaN(bNum)) {
        return aNum - bNum;
    }

    // Fall back to alphabetical comparison
    return String(keyA).localeCompare(String(keyB));
}

const handleCopy = (textToCopy) => navigator.clipboard.writeText(textToCopy);

const tab = '&emsp;';

const tabTag = <>&emsp;</>;

/**
 * Coerce a raw query-string value (always a string, or null when absent)
 * into the type declared for a page parameter.
 */
function coercePageParam(raw, type) {
    if (raw === null || raw === undefined) return undefined;
    switch (type) {
        case 'int': {
            const n = parseInt(raw, 10);
            return Number.isNaN(n) ? undefined : n;
        }
        case 'float': {
            const n = parseFloat(raw);
            return Number.isNaN(n) ? undefined : n;
        }
        case 'bool':
            return raw === 'true' || raw === '1';
        case 'list':
            // Comma-separated → array of non-empty trimmed strings
            return raw.split(',').map(s => s.trim()).filter(Boolean);
        case 'string':
        default:
            return raw;
    }
}

/**
 * usePageParams — declarative query-param reader for routed "pages".
 *
 * Reads a declared set of URL query params on mount (and whenever `ready`
 * flips true), coerces them to their declared types, applies defaults, and
 * invokes `onReady(params)` once with the resolved values. Optionally strips
 * the params from the URL afterward so a refresh doesn't re-trigger the
 * behavior (mirrors the existing seedSync/replaceState pattern).
 *
 * This is the general mechanism for passing parameters to a page via the URL,
 * e.g. navigate(`.../progress?resource=sites&status=error&tab=2`).
 *
 * @param {Object}   schema   Map of paramName -> { type?, default?, alias? }.
 *                            type: 'string'|'int'|'float'|'bool'|'list' (default 'string').
 *                            alias: query-string key if it differs from paramName.
 * @param {Object}   options
 * @param {boolean}  options.ready  Gate — onReady only fires once this is true
 *                                  (so the page can wait for its data to load).
 * @param {Function} options.onReady(params, raw) Called once with resolved params.
 * @param {boolean}  options.clearAfter  Strip consumed params from the URL (default false).
 * @returns {Object} The resolved params (also available synchronously for render).
 */
function usePageParams(schema = {}, { ready = true, onReady, clearAfter = false } = {}) {
    const [searchParams] = useSearchParams();
    const firedRef = useRef(false);

    // Resolve params synchronously so callers can also use them during render.
    const resolved = useMemo(() => {
        const out = {};
        let anyPresent = false;
        for (const [name, cfg = {}] of Object.entries(schema)) {
            const key = cfg.alias || name;
            const raw = searchParams.get(key);
            const coerced = coercePageParam(raw, cfg.type);
            if (coerced !== undefined) {
                out[name] = coerced;
                anyPresent = true;
            } else if ('default' in cfg) {
                out[name] = cfg.default;
            }
        }
        out.__anyPresent = anyPresent;
        return out;
        // Re-resolve when the query string changes.
    }, [searchParams, JSON.stringify(schema)]);

    useEffect(() => {
        if (firedRef.current) return;
        if (!ready) return;
        firedRef.current = true;

        if (typeof onReady === 'function') {
            const { __anyPresent, ...params } = resolved;
            onReady(params, __anyPresent);
        }

        if (clearAfter && resolved.__anyPresent) {
            // Strip only our params; keep anything else on the query string.
            const next = new URLSearchParams(window.location.search);
            for (const [name, cfg = {}] of Object.entries(schema)) {
                next.delete(cfg.alias || name);
            }
            const qs = next.toString();
            window.history.replaceState(
                null,
                '',
                window.location.pathname + (qs ? `?${qs}` : '')
            );
        }
    }, [ready, resolved]);

    const { __anyPresent, ...params } = resolved;
    return params;
}

export default buildRandomId;
export {
    submitHandler,
    statusCodeText,
    parseTextFromHTML,
    formatCWMNotes,
    performStringSearch,
    capitalizeFirstLetter,
    setInitialFormValues,
    setUpdateValues,
    buildStaffOptions,
    buildAddressOptions,
    buildOptionsFromArray,
    rekeyArray,
    reduceArray,
    getStaticArray,
    createValuesArray,
    lowercaseFirstLetter,
    uploadPresignedFile,
    resetAllFormFields,
    sortArrayByKey,
    convertTimestampToTimePicker,
    groupObjectsByKey,
    renameKeysSnakeToCamel,
    renameKeysCamelToSnake,
    showRelativeTime,
    showTimestamp,
    showTimestampStacked,
    useIsMobile,
    isAdminUser,
    handleRequiredFields,
    convertArrayToCSV,
    insertTab,
    handleTabOnKeyDown,
    loadObjectToTextArea,
    handleTextAreaObjectToString,
    convertObjectToString,
    parseJSONSafe,
    stringifyJSONSafe,
    getJSONDisplayString,
    formatJsonAsElements,
    jsonPre,
    sortByKey,
    sortArrayByKeys,
    handleCopy,
    buildGroupedOptionsFromObject,
    buildSelectOptionsFromArray,
    findReactSelectValue,
    tab,
    tabTag,
    usePageParams,
}